import React from "react";

import profile from "../assets/profile.svg";
import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import { CiLinkedin } from "react-icons/ci";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <section
      className="min-h-[85vh] lg:min-h-[78vh] flex items-center "
      id="home"
    >
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-15">
          <div className="flex-1 text-center font-secondary lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.4)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[35px] font-bold leading-[0.8] lg:text-[40px]"
            >
              Akash <span className="mr-4">Gauda </span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]"
            >
              <span className="text-white mr-4">I learn</span>
              <TypeAnimation
                sequence={["Next-js", 2000, "React-js", 2000, "Node-js", 2000]}
                speed={50}
                className="text-accent"
                wrapper="span"
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="mb-8 max-w-lg mx-auto lg:mx-0"
            >
              Passionate React.js Developer crafting dynamic web experiences
              with creativity and precision.
            </motion.p>
            <motion.div
              variants={fadeIn("up", 0.6)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex max-w-max mb-12 mx-auto items-center lg:mx-0 gap-x-6"
            >
              <Link to="contact">
                <button className="btn btn-lg">Contact me</button>
              </Link>
              <Link to="portfolio">
                <a className="text-gradient btn-link cursor-pointer">
                  my portfolio
                </a>
              </Link>
            </motion.div>
            <motion.div
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="flex text-center-[20px] gap-x-6 max-w-max mx-auto lg:mx-0 mt-8 justify-center  lg:justify-between"
            >
              <a
                target="_blank"
                href="https://www.linkedin.com/in/akash-gauda-3b106b237/"
              >
                <CiLinkedin />
              </a>
              <a target="_blank" href="https://github.com/gaudakash">
                <FaGithub />
              </a>
            </motion.div>
          </div>
          <motion.div
            variants={fadeIn("down", 0.3)}
            initial="hidden"
            whileInView={"show"}
            className="hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px]"
          >
            <div>
              <img src={profile} alt="Candidate-Ppicture" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Home;
